<div class="contacts-container">
  <h3 class="section-title">
    <i class="pi pi-phone mr-2"></i>
    Interlocuteurs
  </h3>

  <!-- Contacts principaux -->
  <div class="contacts-section mb-3" *ngIf="contacts?.length">
    <h4 class="subsection-title">Contacts principaux</h4>

    <div class="contact-list">
      <div *ngFor="let contact of contacts" class="contact-item">
        <p-avatar
          [label]="getInitials(contact.fullName)"
          shape="circle"
          [style]="{
            'background-color': getAvatarColor(contact.fullName),
            color: 'white',
          }"
          size="normal"
          class="mr-2"
        >
        </p-avatar>
        <div class="contact-info">
          <div class="name-profession">
            <span class="name">{{ contact.fullName }}</span>
            <span *ngIf="contact.profession?.name" class="profession">{{
              contact.profession?.name
            }}</span>
          </div>
          <div class="contact-details">
            <a
              *ngIf="contact.email"
              [href]="'mailto:' + contact.email"
              class="email"
            >
              <i class="pi pi-envelope mr-1"></i>
              <span>{{ contact.email }}</span>
            </a>
            <a
              *ngIf="contact.phone"
              [href]="'tel:' + contact.phone"
              class="phone"
            >
              <i class="pi pi-phone mr-1"></i>
              <span>{{ contact.phone }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Superviseur des travaux -->
  <div class="supervisor-section mb-3" *ngIf="worksSupervisor">
    <h4 class="subsection-title">Conducteur de travaux</h4>

    <div class="contact-item">
      <p-avatar
        [label]="getInitials(worksSupervisor.fullName)"
        shape="circle"
        [style]="{
          'background-color': getAvatarColor(worksSupervisor.fullName),
          color: 'white',
        }"
        size="normal"
        class="mr-2"
      >
      </p-avatar>
      <div class="contact-info">
        <div class="name-profession">
          <span class="name">{{ worksSupervisor.fullName }}</span>
          <span *ngIf="worksSupervisor.profession?.name" class="profession">{{
            worksSupervisor.profession?.name
          }}</span>
        </div>
        <div class="contact-details">
          <a
            *ngIf="worksSupervisor.email"
            [href]="'mailto:' + worksSupervisor.email"
            class="email"
          >
            <i class="pi pi-envelope mr-1"></i>
            <span>{{ worksSupervisor.email }}</span>
          </a>
          <a
            *ngIf="worksSupervisor.phone"
            [href]="'tel:' + worksSupervisor.phone"
            class="phone"
          >
            <i class="pi pi-phone mr-1"></i>
            <span>{{ worksSupervisor.phone }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>

  <!-- Contacts de l'affaire -->
  <div class="affair-contacts-section" *ngIf="affairsContacts?.length">
    <h4 class="subsection-title">Contacts affaire</h4>

    <div class="contact-list">
      <div *ngFor="let contact of affairsContacts" class="contact-item">
        <p-avatar
          [label]="getInitials(contact.fullName)"
          shape="circle"
          [style]="{
            'background-color': getAvatarColor(contact.fullName),
            color: 'white',
          }"
          size="normal"
          class="mr-2"
        >
        </p-avatar>
        <div class="contact-info">
          <span class="name">{{ contact.fullName }}</span>
          <div class="contact-details">
            <a
              *ngIf="contact.email"
              [href]="'mailto:' + contact.email"
              class="email"
            >
              <i class="pi pi-envelope mr-1"></i>
              <span>{{ contact.email }}</span>
            </a>
            <a
              *ngIf="contact.phone"
              [href]="'tel:' + contact.phone"
              class="phone"
            >
              <i class="pi pi-phone mr-1"></i>
              <span>{{ contact.phone }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Message si aucun contact n'est disponible -->
  <div
    *ngIf="!contacts?.length && !worksSupervisor && !affairsContacts?.length"
    class="empty-message"
  >
    Aucun interlocuteur défini pour cette intervention
  </div>
</div>
